module.exports = __webpack_public_path__ + "h5/img/logo9.66a8ba9a.png";